(function () {
  function initFooterAccordions() {
    document.querySelectorAll('[data-footer-accordions]').forEach(function (accordion) {
      accordion.querySelectorAll('[data-footer-accordion]').forEach(function (item) {
        var toggle = item.querySelector('[data-footer-accordion-toggle]');
        var panel = item.querySelector('[data-footer-accordion-panel]');

        if (!toggle || !panel || toggle.dataset.footerReady === 'true') return;

        toggle.dataset.footerReady = 'true';

        function setPanelHeight() {
          if (window.matchMedia('(max-width: 992px)').matches) {
            panel.style.height = item.classList.contains('is-open') ? panel.scrollHeight + 'px' : '0px';
          } else {
            panel.style.height = '';
          }
        }

        toggle.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          item.classList.toggle('is-open', willOpen);
          toggle.setAttribute('aria-expanded', String(willOpen));
          setPanelHeight();
        });

        window.addEventListener('resize', setPanelHeight);
        setPanelHeight();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initFooterAccordions);
  document.addEventListener('shopify:section:load', initFooterAccordions);
})();
